import { useMemo } from 'react';
import useUser from '../user';
import { useCart } from '~/lib/cart';

import { SUMO_DAY_SLUG } from '~/lib/campaigns/constants';

export default function useSumoDay(): any {
  const { user, session } = useUser();
  const { cart } = useCart();

  const isSumoDay = useMemo(
    () => session?.campaigns?.includes(SUMO_DAY_SLUG),
    [session],
  );

  const showSumoDayIncentive = useMemo(
    () =>
      isSumoDay &&
      !user?.id &&
      cart?.has_sd_product &&
      !cart?.coupon?.coupon_id,
    [isSumoDay, user, cart],
  );

  return {
    isSumoDay,
    showSumoDayIncentive,
  };
}
